import { api } from './api';
import type { VipAnswer, VipResponse, VipRound } from '../types/vip-surveys';

export const vipSurveys = {
  getRound: async (code: string): Promise<VipRound> =>
    (await api.get(`/vip-surveys/${encodeURIComponent(code)}`)).data,
  getMyResponse: async (code: string): Promise<VipResponse | null> =>
    (await api.get(`/vip-surveys/${encodeURIComponent(code)}/me`)).data,
  submit: async (code: string, answers: VipAnswer[]): Promise<VipResponse> =>
    (await api.post(`/vip-surveys/${encodeURIComponent(code)}/responses`, { answers })).data,
};
